import { memo } from 'react'
import DelimitedFlex from '../DelimitedFlex'
import { FlexProps } from '../primitives/themeMappings/props'

interface WeedgetHeaderProps extends FlexProps {
  variant?: 'default' | 'compact'
}

const WeedgetHeader: FC<WeedgetHeaderProps> = ({ children, variant = 'default', ...props }) => {
  const minHeight = variant === 'compact' ? 32 : 52

  return (
    <DelimitedFlex
      $alignItems='center'
      $justifyContent='space-between'
      $px='md'
      $pt='md'
      $pb={variant === 'compact' ? 'sm' : 'md'}
      $gap='md'
      $minHeight={minHeight}
      $borderColor={variant === 'compact' ? 'transparent' : 'grayscale.100'}
      style={{ cursor: 'move' }}
      {...props}
    >
      {children}
    </DelimitedFlex>
  )
}

export default memo(WeedgetHeader)
